// import OverlappingMarkerSpiderfier from 'overlapping-marker-spiderfier';

let oms = null;

export const initializeSpiderfier = async (map) => {
  if (!window.google) {
    console.error("Google Maps API is not loaded.");
    return;
  }
  
  // if (oms) return oms;
  if (oms)
    oms.unspiderfy();

  const { default: OverlappingMarkerSpiderfier } = await import("overlapping-marker-spiderfier");
  oms = new OverlappingMarkerSpiderfier(map, {
    keepSpiderfied: true,
    nearbyDistance: 30,
    markersWontMove: true,
    markersWontHide: true,
    spiderfiedShadowColor: false,
    circleFootSeparation: 80,
    spiralFootSeparation: 80,
    legWeight: 2,
  });

  // oms.addListener('click', (marker) => {});

  // oms.addListener('spiderfy', (markers) => {});

  // oms.addListener('unspiderfy', (markers) => {});

  return oms;
};

export const getOms = () => oms;

export const resetSpiderfier = () => {
  oms = null;
};

export const spiderfyMarkers = (markers) => {
  if (oms && markers && markers.length > 1) {
    setTimeout(() => {
      oms.spiderfy(markers);
    }, 500);
  }
};

export const addMarkerToSpiderfy = (marker) => {
  if (oms) {
    oms.addMarker(marker);
  }
};